module.exports = __webpack_public_path__ + "img/newt6.b90c79b4.png";